export default __webpack_public_path__ + "static/media/icon-twitter.a0c5f64d.svg";